import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import SelectX from '../../project-portal/form/SelectX';
import { Employee } from '../../api/Endpoints/Employee';
import TextInput from '../../project-portal/form/TextInput';
import moment from 'moment';
import toast from 'react-hot-toast';
import { AssignUser } from '../../api/Endpoints/Assign';
import { LoadingButton } from '@mui/lab';
import { VendorAPI } from '../../api/Endpoints/Vendor';

function SendForMaintanencePopup({ editID, setEditId, itemId, UnassignId, setUnAssignId, onUpdate }) {

    const [open, setOpen] = useState(false);

    const [formButtonStatus, setFormButtonStatus] = useState({
        label: "Send",
        loading: false,
        disabled: false,
    });
    // pushing to live
    const scheme = yup.object().shape({
        vendor: !UnassignId && yup.object().required("Vendor is requrired"),
        release_note: UnassignId && yup.string().required("Release Note is requrired"),
        cost: UnassignId && yup.string().required("Cost is requrired"),
        assign_note: !UnassignId && yup.string().required("Note is requrired"),
    });

    const { register, handleSubmit, watch, formState: { errors }, control, setValue, getValues, reset } = useForm({ resolver: yupResolver(scheme), criteriaMode: 'all' });

    const handleClose = () => {
        setTimeout(() => {
            setUnAssignId(0)
        }, 300);

        setEditId(0);
        setOpen(false);
        reset()
    };

    useEffect(() => {
        if (UnassignId > 0) {
            setOpen(true);
        } else if (editID === undefined) {
            setOpen(true);
        }
    }, [editID, UnassignId]);

    const fetchDetails = () => {
        setOpen(true);
    };

    const fetchVendors = (e) => {
        return VendorAPI.get({ keyword: e }).then(response => {
            if (typeof response.data.data.data !== 'undefined') {
                return response.data.data.data;
            } else {
                return [];
            }
        });
    };



    const onSubmit = (data) => {

        setFormButtonStatus({ ...formButtonStatus, loading: true });



        let dataToSubmit = {
            vendor_id: data.vendor?.id,
            assigned_note: data.assign_note,
            item_id: itemId,
            cost: data.cost,
            return_note: data.release_note
        };


        let action;

        if (UnassignId > 0) {
            dataToSubmit.id = UnassignId
            action = VendorAPI.returnFromMaintance(dataToSubmit)
        } else {
            action = VendorAPI.sendToMaitanance(dataToSubmit)
        }
        action.then(response => {

            setFormButtonStatus({ label: "Send", loading: false, disabled: false });
            if (response.data.error) {
                toast.error(response.data.message, { autoClose: 2000 });
                return
            }
            toast.success(response.data.message)
            onUpdate()
            handleClose();

        }).catch(errors => {

            toast.error("Internal server error");
            setFormButtonStatus({ label: "Send", loading: false, disabled: false });
            handleClose()
        })
    }


    return (
        <div>
            <Dialog
                open={open}
                onClose={handleClose}
                sx={{ '& .MuiDialog-paper': { width: '500px', maxWidth: '500px' } }}
            >
                <DialogTitle textAlign={'center'}>{UnassignId > 0 ? "Return From Maintenance" : "Send For Maintenance"}</DialogTitle>
                <DialogContent  >
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {!UnassignId && (
                            <Grid sx={{ mt: 2 }} item xs={12}>
                                <SelectX
                                    label={"Vendor"}
                                    options={fetchVendors}
                                    control={control}
                                    error={errors?.vendor?.id ? errors?.vendor?.id?.message : false}
                                    error2={errors?.vendor?.message ? errors?.vendor?.message : false}
                                    name={'vendor'}
                                    defaultValue={watch('vendor')}
                                />
                            </Grid>
                        )}
                        {UnassignId ? (
                            <Grid item xs={12} mt={2}>

                                <TextInput
                                    control={control}
                                    name="cost"  // Ensure no extraneous characters
                                    label="Cost"
                                    value={watch('cost')}
                                    type="number"
                                />

                            </Grid>) : null}
                        <Grid item xs={12} mt={2}>
                            {UnassignId ? (
                                <TextInput
                                    control={control}
                                    name="release_note"  // Ensure no extraneous characters
                                    label="Return  Note"
                                    value={watch('release_note')}
                                    row={5}
                                    isMultiline
                                />
                            ) : (
                                <TextInput
                                    control={control}
                                    name="assign_note"
                                    label="Assign Note"
                                    value={watch('description')}
                                    row={5}
                                    isMultiline
                                />
                            )}

                        </Grid>
                        <Grid sx={{ pt: 2 }} item xs={12} display={'flex'} justifyContent={'end'}>      <DialogActions>


                            <Button onClick={handleClose} variant='outlined' color='error' sx={{ marginRight: 1 }}>Close</Button>

                            <LoadingButton loading={formButtonStatus.loading} disabled={formButtonStatus.disabled}
                                variant="outlined" type="submit">{formButtonStatus.label}</LoadingButton>

                        </DialogActions>
                        </Grid>
                    </form>
                </DialogContent>





            </Dialog>
        </div >
    );
}

export default SendForMaintanencePopup;
